import React from 'react';
function DragIcon({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" d="M8.65 8.35h6.7M8.65 12.35h6.7M8.65 16.35h6.7" />
    </svg>
  );
}

export default DragIcon;
